import '@fancyapps/fancybox';


$( '.sponsor-carousel' ).each( function() {
	const $this = $( this );
	const $container = $this.closest( '.carousel-container' );

	const swiperConfig = {
		navigation: {
			nextEl: $container.find( '.carousel-next' )[ 0 ],
			prevEl: $container.find( '.carousel-previous' )[ 0 ],
		},
		slidesPerView: 1,
		spaceBetween: 20,
		breakpoints: {
			1280:
				{
					slidesPerView: 4,
					spaceBetween: 40,
				},
		},
		loop: true,
		autoplay: {
			delay: 1000,
		},
		speed: 1000,
	};

	const swiper = new Swiper( this, swiperConfig );
} );

$( '.review-carousel' ).each( function() {
	const $this = $( this );
	const $container = $this.closest( '.carousel-container' );

	const swiperConfig = {
		slidesPerView: 1,
		spaceBetween: 40,
		loop: true,
		autoplay: {
			delay: 3000,
		},
		speed: 1000,
	};

	const swiper = new Swiper( this, swiperConfig );
} );
